import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../assets/img/upload-title.png'


const _hoisted_1 = { class: "apply-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "apply-title",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "apply-content" }
const _hoisted_4 = { class: "flex-item" }
const _hoisted_5 = { class: "apply-item-tips" }
const _hoisted_6 = { class: "apply-item-form" }
const _hoisted_7 = {
  key: 3,
  class: "flex-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareBtn = _resolveComponent("ShareBtn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formItems, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "apply-item",
          key: index
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", {
              class: "apply-item-title",
              style: item.style || ''
            }, _toDisplayString(item.title), 5),
            _createVNode("div", _hoisted_5, _toDisplayString(item.tip ? `（${item.tip}）` : item.required ? '（必填）' : ''), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            (item.type === 'text')
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 0,
                  maxlength: item.maxLength || 1000,
                  required: item.required,
                  "onUpdate:modelValue": ($event: any) => (_ctx.form[item.key] = $event),
                  type: "text"
                }, null, 8, ["maxlength", "required", "onUpdate:modelValue"])), [
                  [_vModelText, _ctx.form[item.key]]
                ])
              : _createCommentVNode("", true),
            (item.type === 'date')
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  required: item.required,
                  "onUpdate:modelValue": ($event: any) => (_ctx.form[item.key] = $event),
                  type: "date"
                }, null, 8, ["required", "onUpdate:modelValue"])), [
                  [_vModelText, _ctx.form[item.key]]
                ])
              : _createCommentVNode("", true),
            (item.type === 'textarea')
              ? _withDirectives((_openBlock(), _createBlock("textarea", {
                  key: 2,
                  maxlength: item.maxLength,
                  required: item.required,
                  "onUpdate:modelValue": ($event: any) => (_ctx.form[item.key] = $event),
                  placeholder: item.placeholder
                }, null, 8, ["maxlength", "required", "onUpdate:modelValue", "placeholder"])), [
                  [_vModelText, _ctx.form[item.key]]
                ])
              : _createCommentVNode("", true),
            (item.type === 'radio')
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.items, (v, i) => {
                    return (_openBlock(), _createBlock("label", {
                      key: i,
                      class: v.value === _ctx.form[item.key] ? 'active' : '',
                      onClick: ($event: any) => (_ctx.form[item.key] = v.value)
                    }, _toDisplayString(v.text), 11, ["onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createVNode("button", {
        class: "apply-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitConfirm()))
      })
    ]),
    _createVNode(_component_ShareBtn)
  ]))
}